import { supabase } from "../supabaseClient";

/** 컬렉션에 양파 추가 */
export async function addCollection(
  userId: string,
  onionType: string
) {
  const { error } = await supabase
    .from("collection")
    .insert({
      user_id: userId,
      onion_type: onionType,
    });

  if (error) throw error;
}
